import {
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'

import { RootState } from '../../types'

import {
  ProductInformationState,
  ProductInfo,
} from './types'

export const initialState: ProductInformationState = {}

export const productInformationSlice = createSlice({
  name: 'productInformation',
  initialState,
  reducers: {
    setProductInfo: (state, action: PayloadAction<ProductInfo>) => {
      state.productInfo = action.payload

      return state
    },
  },
})

export const { setProductInfo } = productInformationSlice.actions

export const productInformationSelectors = { productInformation: (state: RootState) => state.productInformation }

export default productInformationSlice.reducer

export * from './types'
